import { Box, alpha, styled } from '@mui/material';

import { GOLD_LIGHT, GOLD_TEXT } from './sheet.styles';

/**
 * The career Pro pitch's scrolling body and the note above its headline. The
 * sheet around it (header, price, CTA) is in sheet.styles.tsx, the Free vs Pro
 * table in compare.tsx.
 */

export const PitchBody = styled(Box)({
  display: 'flex',
  flexDirection: 'column',
  minHeight: 0,
  overflowY: 'auto',
});

export const ShortNote = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  gap: 8,
  // The first line read, inside the header above the headline.
  margin: '12px 0 2px',
  padding: '9px 12px',
  borderRadius: 12,
  fontSize: 13.5,
  fontWeight: 500,
  lineHeight: 1.4,
  color: theme.palette.text.primary,
  backgroundColor: alpha(theme.palette.primary.main, 0.05),
  border: `1px solid ${alpha(theme.palette.primary.main, 0.12)}`,
  '& b': { color: theme.palette.text.primary, fontWeight: 700 },
  // What the paywall is offering here ("Docker Fundamentals is free with
  // Pro"): in the pass's gold, so it reads as the offer, not a disclaimer.
  '& em': {
    fontStyle: 'normal',
    fontWeight: 700,
    color: GOLD_TEXT,
    ...theme.applyStyles('dark', { color: GOLD_LIGHT }),
  },
}));

export const CheckoutHead = styled(Box)({
  display: 'flex',
  alignItems: 'center',
  gap: 4,
  padding: '14px 16px 0',
});
